import React from 'react';
import { inject, observer } from 'mobx-react';
import SudoTag from 'app/components/SudoTag';

/**
 * Error text for a tool call, step, or turn. Raw errors can expose provider and internal details,
 * so only sudo users see them, marked with a SUDO tag; everyone else sees the fallback.
 * Set `showMessage` for errors written to be shown to every user, such as device RBAC denials.
 */
const KaizenErrorMessage = ({ $auth, message, showMessage = false, fallback = 'Something went wrong' }) => {
  if (!message) {
    return fallback;
  }

  if (showMessage) {
    return message;
  }

  if ($auth.isSudoer) {
    return (
      <>
        <SudoTag fontSize={11} /> <span title={message}>{message}</span>
      </>
    );
  }

  return fallback;
};

export default inject('$auth')(observer(KaizenErrorMessage));
